module.exports = __webpack_public_path__ + "static/media/preview.bd777ca1.png";